export type HeroLcpImageDimensions = {
  width: number
  height: number
}

export type HeroLcpSources = {
  mobile: string
  tablet: string
  desktop: string
}

export const HOME_HERO_LCP_DIMENSIONS = {
  mobile: { width: 828, height: 459 },
  tablet: { width: 1200, height: 665 },
  desktop: { width: 1440, height: 798 }
} satisfies Record<keyof HeroLcpSources, HeroLcpImageDimensions>

export const HOME_HERO_LCP_SOURCES: HeroLcpSources = {
  mobile: '/assets/first-page-stadium-mobile.webp',
  tablet: '/assets/first-page-stadium-tablet.webp',
  desktop: '/assets/first-page-stadium.webp'
}
